/* TO DISABLE */
$(function () {
    function slideIn () {
        var $this = $(this);
        var width = $(this).attr("data-content-width") || 268;
        $this.stop(true, false).animate({ width: width }, 500, function () {
            $this.addClass("advertisementBoxWrapper--opened");
        });
    }
    function slideOut () {
        var $this = $(this);
        $this.stop(true, false).animate({ width: 0 }, 500, function () {
            $this.removeClass("advertisementBoxWrapper--opened");
        });
    }

    /*function slideOut2 () {
        var $this = $(this);
        $this.stop(true, false).animate({ width: '38px' }, 500);
    }*/

    var adboxes = $(".js-advertisementBoxWrapper");
    adboxes.each(function (index, obj) {
       if($(this).hasClass("js-defaultOpened")){

           slideIn.call(this);
       }
    });

    $(document).on("click", ".js-closeAdvertisementBox", function () {
        var $button = $(this);
        var $wrapper = $button.closest(".js-advertisementBoxWrapper");
        $wrapper.css({
            display: "block"
        });
        $wrapper.each(slideOut);
        $wrapper;
    });

    $(document).on("click", ".advertisementTab-title", function (event) {
        event.preventDefault();
        var $button = $(this);
        var $wrapper = $button.closest(".js-advertisementBoxWrapper");
        if ($wrapper.is(".advertisementBoxWrapper--opened")) {
            $wrapper.each(slideOut);
        } else {
            $wrapper.each(slideIn);
        }
    });

    $(document).on("mouseenter", ".js-advertisementBoxWrapper:not(.advertisementBoxWrapper--notHover)", slideIn);
    $(document).on("mouseleave", ".js-advertisementBoxWrapper:not(.advertisementBoxWrapper--notHover)", function (event) {
        var $relatedTarget = $(event.relatedTarget);
        if (!$relatedTarget || ($relatedTarget && !$relatedTarget.is(".js-validationMessage"))) {
            var $messages = $(".js-validationMessage");
            $messages.removeClass("fshr-validationMessage--show");
            $(this).each(slideOut);
        }
    });


});


/* TO DISABLE */
/**
 * discount box
 * */
(function ($, global) {
    var cookieName = "discounBox-closed";
    var discountBoxClosedClass = "fshr-discountBox--closed";

    $(document).on("click", ".js-discountBox--close", function (event) {
        event.preventDefault();
        var $closeButton = $(this);
        var $box = $closeButton.closest(".fshr-discountBox");
        $box.addClass(discountBoxClosedClass);
        global.cookie.set(cookieName, 1, 14);
    });
    $(document).on("click", ".js-discountBox--open." + discountBoxClosedClass, function (event) {
        event.preventDefault();
        var $box = $(this);
        $box.removeClass(discountBoxClosedClass);
        global.cookie.set(cookieName, 0, 14);
    });
})(jQuery, globalWrapper.fshr);
